import {Fragment} from 'preact/compat'
import {Dialog, Transition} from '@headlessui/react'
import {close} from '../../assets'
import {useRemoveModal} from "./useRemoveModal";

const RemoveModal = props => {
    // Destructured props
    const {
        open,
        setOpen,
        product,
        handleProductDelete,
        source = "default"
    } = props;

    // Component logic data
    const componentProps = useRemoveModal({
        setOpen,
        handleProductDelete,
        source
    });

    // Destructured component logic data
    const {
        cancelButtonRef,
        handleClick
    } = componentProps;

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-fade-modal bg-opacity-75 transition-opacity" />
                </Transition.Child>
                <div className="fixed inset-0 z-10 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-2 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel
                                className={`relative transform overflow-hidden rounded-lg text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg p-6 bg-light-gray `}>
                                <div>
                                    <div className="text-start">
                                        <div className={'flex justify-between'}>
                                            <Dialog.Title as="h3" className={`max-w-[20rem] text-[20px] font-semibold leading-6 text-gray-800`}>
                                                Você deseja realmente excluir o serviço abaixo?
                                            </Dialog.Title>
                                            <button
                                                className={'flex w-5 select-none'}
                                                onClick={() => setOpen(false)}
                                            >
                                                <img src={close} alt="cancel" className={`w-full`} />
                                            </button>
                                        </div>
                                        <div className={`mt-2 border w-[57px] border-sabin-red-default`} />
                                        <div className="mt-2">
                                            <p className={`mt-8 text-base font-bold text-gray-500`}>
                                                {product.name}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-5 flex gap-[1rem]">
                                    <button
                                        type="button"
                                        className={`inline-flex w-full justify-center items-center rounded-md bg-light-green px-3 py-2 text-sm text-white shadow-sm ring-1 ring-inset ring-light-green hover:bg-dark-green sm:col-start-1 sm:mt-0 select-none`}
                                        onClick={() => setOpen(false)}
                                        ref={cancelButtonRef}
                                    >
                                        CONTINUAR COM O SERVIÇO
                                    </button>
                                    <button
                                        type="button"
                                        className={`inline-flex w-full justify-center items-center rounded-md bg-white px-3 py-2 text-sm text-[#6c757d] hover:text-white border border-inherit shadow-sm hover:bg-hover-gray focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white sm:col-start-2 select-none`}
                                        onClick={() => handleClick(product[source === "default" ? "stockItem" : "itemId"])}
                                    >
                                        DESEJO APAGAR
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default RemoveModal;
